








import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly border!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/purchases/components/cancellation/components/button/Button.vue